import React from 'react';
import { Box, Typography } from '@mui/material';

export const NoRowsOverlay: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 2
      }}
    >
      <Typography color="text.secondary">
        No students found
      </Typography>
    </Box>
  );
};